export default __webpack_public_path__ + "static/media/icon-newsfeed-gray.fd8388c4.svg";